'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = require('babel-runtime/helpers/extends');

var _extends6 = _interopRequireDefault(_extends5);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * This is a convenience function for allowing custom
 * reducers to be broken into their own files,
 * and still mount onto other reducers.
 *
 * A good example is the home reducer, which is mounting
 * on pages but has lots of home-specific logic which
 * is kept isolated.
 *
 * Arguments:
 * reducer - the reducer to mount
 * mountPoint - the key to mount the reducer to
 */

var iterateOverObject = function iterateOverObject(obj, fn) {
  return (0, _keys2.default)(obj).reduce(function (newObj, key) {
    var el = obj[key];
    if (typeof el === 'function') {
      return (0, _extends6.default)({}, newObj, (0, _defineProperty3.default)({}, key, fn(el)));
    }

    return (0, _extends6.default)({}, obj, (0, _defineProperty3.default)({}, key, iterateOverObject(el, fn)));
  }, {});
};

var mountReducer = function mountReducer(reducer, mountPoint) {
  return iterateOverObject(reducer, function (fn) {
    return function (state, action) {
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, mountPoint, fn(state[mountPoint], action)));
    };
  });
};

exports.default = mountReducer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/mountReducer.js
// module id = 1302
// module chunks = 0